import styled from "styled-components";
import { theme } from "ui";

export const Container = styled.div`
  margin: 2rem 0;

  transition: all 0.2s ease-in-out;
  .active {
    border: 2px solid ${theme.colors.secondary["250"]};
  }
  .disabled:hover {
    border: 1px solid ${theme.colors.secondary["250"]};
    color: ${theme.colors.secondary["250"]};
  }
`;

export const BoxOptions = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding-bottom: 0.4rem;
  min-height: 8rem;
`;

export const BoxTitle = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
`;

export const TextTitle = styled.h3`
  color: ${theme.colors.neutral["720"]};
  margin-bottom: 4px;
  text-align: left;
  font-size: 1.15rem;
  line-height: normal;
  font-weight: ${theme.typography.fontWeight["400"]};
  font-family: ${theme.typography.fontFamily.chivo};
`;

export const SubTitle = styled.h3`
  padding-left: 0.65rem;
  color: ${theme.colors.neutral["750"]};
  line-height: normal;
  font-size: 1.15rem;
  font-weight: ${theme.typography.fontWeight["700"]};
  font-family: ${theme.typography.fontFamily.chivo};
`;

export const TitleHighlight = styled.span`
  color: ${theme.colors.neutral["550"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1rem;
  font-weight: ${theme.typography.fontWeight["900"]};
  line-height: 150%;
  letter-spacing: -0.02rem;
`;

export const TextHighlight = styled.p`
  color: ${theme.colors.neutral["330"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 0.85rem;
  font-weight: ${theme.typography.fontWeight["400"]};
  line-height: 150%;
  letter-spacing: -0.0165rem;
`;

export const TextHighlightWrapper = styled.div``;

export const TextHighlightWrapperRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FlagDiscount = styled.span`
  /* color: ${theme.colors.secondary["400"]};
  padding: 0.2rem 0.5rem;
  border: 1px solid ${theme.colors.secondary["400"]};
  border-radius: 1rem;
  margin-left: 0.2rem; */
  display: flex;
  padding: 0rem 0.35rem;
  align-items: flex-start;
  align-self: stretch;
  margin-left: 8px;
  background: ${theme.colors.secondary["250"]};
  color: ${theme.colors.neutral.white};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 0.85rem;
  font-weight: ${theme.typography.fontWeight["500"]};
  line-height: 150%;
  letter-spacing: -0.0165rem;
  border-radius: 8px;
`;

export const Box = styled.div`
  padding: 0.65rem;
  border-radius: 6px;
  max-width: 8.65rem;
  min-height: 5.65rem;
  max-height: 5.65rem;
  border: 1px solid ${theme.colors.neutral["95"]};

  box-sizing: content-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* justify-content: center; */
  /* align-items: center; */
  cursor: pointer;
`;
